var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Welcome to your new single-page application, built with "),_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank"}},[_vm._v("Vue.js")]),_vm._v(".")])
}]

export { render, staticRenderFns }